export interface FinancialDocument {
    amount: number;
    applyDiscount: boolean;
    balance: number;
    checked?: boolean;
    companyCode: string;
    countryCode: string;
    contract: string;
    createDate: string;
    createDateObj?: Date;
    createDateTimestamp?: number;
    currencyCode: string;
    customerCode: string;
    customerJobsiteNumber: string;
    daysOverDue: number;
    daysToDue: number;
    debitFlag: boolean;
    discount: number;
    dispute: boolean;
    disputeStatusCode: string;
    disputeStatusDesc: string;
    disputeCompromiseDate: string;
    disputeCompromiseDateObj?: Date;
    disputeId: number;
    disputeResolutionDate: string;
    disputeResolutionDateObj: Date;
    disputeCode: number;
    divisionCode: string;
    docStatusCode: string;
    docStatusDesc: string;
    documentCode: string;
    documentId: number;
    documentItem: string;
    documentTypeCode: string;
    documentTypeDesc: string;
    dueDate: string;
    dueDateObj?: Date;
    dueDateTimestamp?: number;
    fiscalControlNumber: string;
    index?: number;
    invoiceReviewed: boolean;
    invoiceReviewedDesc?: string;
    jobNumber: string;
    jobSiteCode: string;
    jobSiteDesc: string;
    paymentFlag: boolean;
    paymentProcessFlag: boolean;
    paymentsBalance: number;
    plantDesc: string;
    purchaseOrder: string;
    relatedPurchaseOrders?: Array<RelatedDocument>;
    relatedContracts?: Array<RelatedDocument>;
    referenceNumber: string;
    relatedDocument: string;
    recordBlocked: number;
    salesOrgCode: string;
    salesOfficeCode: string;
    totalContracts: number;
    totalPO: number;
    trafficLightId?: number;
    payment?: number;
    expectedPayment?: number;
    accountingFiscalYear?: number;
    taxRate: number;
////////////////////////////////////////////////////////////
    //for DocumentsDTO used in Reconcile.component.ts
    flagDBExist?: boolean;
    duplicateFlag?: boolean;
    errAmntClearing?: boolean;
    errFlagClearing?: boolean;
    errMsgClearing?: string;
    isApply?: boolean;
    originalAmount?: number;
////////////////////////////////////////////////////////////
    //Acces log
    blobDateCreate?: Date;
    viewDateCreate?: Date;
    customerDesc?: string;
    downloadedBy?: string;

    // for AoT compilation
    isSpecialInvoice?: boolean;
}

export interface FinancialDocumentDTO {
    documents: Array<FinancialDocument>;
}

// ==========================================================================================================================
// Billing Types Code
// ==========================================================================================================================

export interface BillingTypeSpecialInvoice {
    billingTypeCode: string;
    billingTypeDesc: string;
}

// ==========================================================================================================================
// Delivery Ticket
// ==========================================================================================================================

interface Unit {
    unitCode: string;
    unitId: number;
}

interface TicketItem {
    amount: number;
    delivery: string;
    deliveryDate: string;
    deliveryDateObj?: Date;
    deliveryQuantity: number;
    freightAmount: number;
    productDesc: string;
    taxAmount: number;
    ticketCode: number;
    unit: Unit;
    unitPrice: number;
}

interface File {
    blobDocumentID: number;
    documentTypeCode: string;
    documentTypeDesc: string;
    ticketCode: string;
}

export interface DeliveryTicket {
    contract: string;
    docDate: string;
    docDateObj?: Date;
    externalDelivery: string;
    pointOfDeliveryAddress: string;
    pointOfDeliveryCode: number;
    pointOfDeliveryDesc: string;
    purchaseOrder: string;
    ticketCode: number;
    ticketItem: Array<TicketItem>;
    files: Array<File>;
}

export interface DeliveryTickets {
    tickets: Array<DeliveryTicket>;
}

// ==========================================================================================================================
// Applied Document
// ==========================================================================================================================

export interface AppliedDocument {
    appliedAmount: number;
    appliedDate: string;
    appliedDateObj?: Date;
    documentDate: string;
    documentDateObj?: Date;
    documentNumber: number;
    originalAmount: number;
    referenceNumber: string;
    typeDocument: string;
}

export interface AppliedDocumentDTO {
    documentApplied: Array<AppliedDocument>;
}

// ==========================================================================================================================
// Ticket Pricing Summary
// ==========================================================================================================================

export interface TicketSummary {
    deliveryQuantity: number;
    productDesc: string;
    totalPrice: number;
    unit: Unit;
    unitPrice: number;
    unitPriceTax: number;
}

export interface TicketsPricingSummary {
    ticketsSummary: Array<TicketSummary>;
}

// ==========================================================================================================================
// Ticket Report
// ==========================================================================================================================

export interface TicketFile {
    blobDocumentId?: number;
    customerReference?: string;
    docStatus: number;
    documentTypeCode: number;
    documentTypeDesc?: string;
    showInTable?: boolean;
}

export interface Ticket {
    files: Array<TicketFile>;
    statusTicket: number;
    ticketCode: string;
    externalDelivery?: string;
}

export interface Invoice {
    blobDocumentIdPDF: number;
    blobDocumentIdXML: number;
    documentCode: string;
    documentId: number;
    referenceNumber: string;
    tickets: Array<Ticket>;
}

export interface TicketReportDTO {
    invoices: Array<Invoice>;
}

// ==========================================================================================================================
// Related Document
// ==========================================================================================================================

export interface RelatedDocument {
    documentCode: string;
}

export interface RelatedDocumentsDTO {
    codes: Array<RelatedDocument>;
}

// ==========================================================================================================================
// reference types
// ==========================================================================================================================

export interface ReferenceType {
    documentTypeCode: string;
    documentTypeDesc: string;
}

export interface SearchedReference {
    cemexReference: string;
    checked: boolean;
    documentId: number;
    documentCode: string;
    documentCode2: string;
    documentCode3: string;
}

// ==========================================================================================================================
// open deliveries
// ==========================================================================================================================

export interface Order {
    amountInventory: number;
    deliveryPosition: string;
    docNumber: string;
    documentDate: string;
    documentDateObj?: Date;
    matDescription: string;
    plan: string;
    quantity: number;
    salesOrganization: number;
    shipStatus: string;
    society: number;
    typeOfDocument: string;
    unit: string;
    unitPrice: number;
    unitPriceTax: number;
}

export interface Delivery {
    society: string;
    salesOrganization: string;
    typeOfDocument: string;
    documentDate: string;
    customDT: string;
    docNumber: string;
    deliveryPosition: string;
    pointOfDelivery: string;
    salesOrder: string;
    purchaseNumber: string;
    quantity: number;
    unit: string;
    matDescription: string;
    unitPrice: number;
    unitPriceTax: number;
    amountInventory: number;
    plan: string;
    shipStatus: string;
    plantName: string;
    podName: string;
    externalIdOfDeliveryNote: string;
    lifex: string;
}

export interface OpenDelivery {
    deliveries: Array<Delivery>;
    orders: Array<Order>;
}

// ==========================================================================================================================
// sales organizatiosn
// ==========================================================================================================================


interface salesOrganization {
    salesOrgCode: string;
}

export interface salesOrganizations {
    salesOrganizations: Array<salesOrganization>;
}
